// 电子发票
export default {
  // 账号中心-发票信息管理
  acc_qryAccountInvoiceListPage: {
    control: 'metaData/liandongMember/dycUmcQryAccountInvoiceListPageService/auto0014/qryAccountInvoiceListPage'
  },
  // 账号中心-发票接收地址管理
  acc_qryInvoiceAddressListPage: {
    control: 'metaData/liandongMember/dycUmcQryInvoiceAddressListPageService/auto0012/qryInvoiceAddressListPage'
  },
  // 账号中心-发票接收地址管理 ：获取orgTreePath
  acc_qryEnterpriseInfoTree: {
    control: 'metaData/liandongMember/dycUmcEnterpriseInfoTreeQryService/auto0018/qryEnterpriseInfoTree'
  },
  // 账号中心-发票信息管理-获取详情
  acc_qryAccountInvoiceDetail: {
    control: 'metaData/liandongMember/dycUmcQryInvoiceInfoDetailService/auto0009/qryAccountInvoiceDetail'
  },
  // 账号中心-发票接收地址管理-获取详情
  acc_qryInvoiceAddressDetail: {
    control: 'metaData/liandongMember/dycUmcQryInvoiceAddressDetailService/auto0010/qryInvoiceAddressDetail'
  },
  // 账号中心-发票接收地址管理-获取数据
  acc_queryCodeList: {
    control: 'metaData/liandongMember/dycUmcDicDataQueryService/auto0135/queryCodeList'
  },
  // 账号中心-发票接收地址管理-设为默认
  acc_setMainInvoiceAddress: {
    control: 'metaData/liandongMember/dycUmcInvoiceAddressSetMainService/auto0006/setMainInvoiceAddress'
  },
  // 账号中心-发票接收地址管理-删除
  acc_operInvoiceAddress: {
    control: 'metaData/liandongMember/dycUmcInvoiceAddressOperService/auto0008/operInvoiceAddress'
  },
  // 账号中心-发票信息管理-设为默认
  acc_setDefaultEnterpriseInvoce: {
    control: 'metaData/liandongMember/dycUmcEnterpriseInvoceSetDefaultService/auto0008/setDefaultEnterpriseInvoce'
  },
  // 账号中心-发票信息管理-删除
  acc_operAccountInvoice: {
    control: 'metaData/liandongMember/dycUmcAccountInvoiceOperService/auto0010/operAccountInvoice'
  },
  // 账号中心-发票信息管理-新增-获取发票抬头列表
  acc_selectLegalEntityInfo: {
    control: 'metaData/liandongMember/ldUmcSelectLegalEntityInformationService/auto0005/selectLegalEntityInfo'
  },
  // 账号中心-发票信息管理-新增
  acc_createInvoiceInfo: {
    control: 'metaData/liandongMember/dycUmcInvoiceInfoAddService/auto0007/createInvoiceInfo'
  },
  // 账号中心-发票信息管理-新增
  acc_updateInvoiceInfo: {
    control: 'metaData/liandongMember/dycUmcInvoiceInfoUpdateService/auto0007/updateInvoiceInfo'
  },
  // 账号中心-发票地址管理-新增
  acc_addInvoiceAddress: {
    control: 'metaData/liandongMember/dycUmcInvoiceAddressAddService/auto0009/addInvoiceAddress'
  },
  // 账号中心-发票地址管理-修改
  acc_upadteInvoiceAddress: {
    control: 'metaData/liandongMember/dycUmcInvoiceAddressUpdateService/auto0009/upadteInvoiceAddress'
  },
  // 财务中心-申请开票-可开票-查询
  acc_qrySalOrderList: {
    control: 'metaData/liandongOrder/dycUocSalOrderListQryService/auto0284/qrySalOrderList'
  },
  // 财务中心-申请开票-可开票-供应商
  acc_qrySupDropDownPageList: {
    control: 'metaData/liandongMember/dycUmcQrySupDropDownPageListService/auto0003/qrySupDropDownPageList'
  },
  // 财务中心-申请开票-可开票-供采购单位
  acc_qryPurDropDownPageList: {
    control: 'metaData/liandongMember/dycUmcQryPurDropDownPageListService/auto0003/qryPurDropDownPageList'
  },
  // 财务中心-申请开票-可开票-供采购单位
  acc_qryAccountInvoiceListPages: {
    control: 'metaData/liandongMember/dycUmcQryAccountInvoiceListPageService/auto0011/qryAccountInvoiceListPage'
  },
  // 财务中心-申请开票-可开票明细列表
  acc_queryInvoiceProductItem: {
    control: 'dyc/fsc/auto/invoice/queryInvoiceProductItem'
  },
  // 财务中心-申请开票-提交
  acc_makeInvoice: {
    control: 'metaData/liandongOrder/lDUocMakeInvoiceService/auto0002/makeInvoice'
  },
  // 财务中心-我的发票
  acc_dealOrderInvoiceCheck: {
    control: 'dyc/fsc/auto/invoice/dealOrderInvoiceCheck'
  },
  // 财务中心-发票信息
  acc_queryInvoiceApplyDetail: {
    control: 'dyc/fsc/auto/invoice/queryInvoiceApplyDetail'
  },
  // 支付对账-销项发票管理-纸质开票确认
  acc_paperInvoiceConfirm: {
    control: 'dyc/fsc/auto/invoice/paperInvoiceConfirm'
  },
  // 支付对账-销项发票管理-修改提交
  acc_dealInvoiceApplyDetail: {
    control: 'dyc/fsc/auto/invoice/dealInvoiceApplyDetail'
  },
  // 支付对账-销项发票管理-纸质发票查看
  acc_queryPaperInvoiceList: {
    control: 'dyc/fsc/auto/invoice/queryPaperInvoiceList'
  },
  // 支付对账-销项发票管理-下载发票/查看失败原因
  acc_queryDownloadInvoiceList: {
    control: '/dyc/fsc/auto/invoice/queryDownloadInvoiceList'
  },
  // 支付对账-销项发票管理-红冲发票申请列表
  acc_queryRedInvoiceApplicationList: {
    control: 'dyc/fsc/auto/invoice/queryRedInvoiceApplicationList'
  },
  // 支付对账-销项发票管理-蓝票信息搜索
  acc_queryBlueInvoiceInfo: {
    control: 'dyc/fsc/auto/invoice/queryBlueInvoiceInfo'
  },
  // 支付对账-销项发票管理-新增红冲
  acc_addRedInvoiceApplication: {
    control: 'dyc/fsc/auto/invoice/addRedInvoiceApplication'
  },
  // 线下开票上传模板下载
  acc_manuallyInvoiceExportModel: {
    control: 'dyc/fsc/auto/invoice/manuallyInvoiceExportModel'
  },
  // 无订单批量开票申请
  acc_batchInvoiceApply: {
    control: 'dyc/fsc/auto/invoice/batchInvoiceApply'
  },
  // 对账单开票提交：
  acc_fscOrderInvoice: {
    control: 'dyc/fsc/auto/invoice/fscOrderInvoice'
  },
  // 对账单开票校验：
  acc_confirmCheckInvoiceInfo: {
    control: 'dyc/fsc/auto/invoice/confirmCheckInvoiceInfo'
  },
  // 发票作废
  acc_cancelInvoiceApply: {
    control: 'dyc/fsc/auto/invoice/cancelInvoiceApply'
  },
  // 发票作废查询
  acc_queryCancelInvoiceApply: {
    control: 'dyc/fsc/auto/invoice/queryCancelInvoiceApply'
  },
  // 无订单批量开票模板下载
  acc_noOrderInvoiceExportModel: {
    control: 'dyc/fsc/auto/invoice/noOrderInvoiceExportModel'
  },
  // z再次调用
  acc_getRedInvoiceInfo: {
    control: 'dyc/fsc/auto/invoice/getRedInvoiceInfo'
  },
  // 手动导入明细模板下载
  acc_manuallyInvoiceDetailExportModel: {
    control: 'dyc/fsc/auto/invoice/manuallyInvoiceDetailExportModel'
  },
  // 手工明细导入解析
  acc_parseInvoiceDetailExcel: {
    control: 'dyc/fsc/auto/invoice/parseInvoiceDetailExcel'
  },
  // 解析无订单
  acc_parseNoOrderInvoiceExcel: {
    control: '/dyc/fsc/auto/invoice/parseNoOrderInvoiceExcel'
  },
  // 解析无订单
  acc_parseManualFeedbackInvoiceExcel: {
    control: 'dyc/fsc/auto/invoice/parseManualFeedbackInvoiceExcel'
  },
  // 无订单 金额
  acc_parseNoOrderInvoiceAmount: {
    control: 'dyc/fsc/auto/invoice/parseNoOrderInvoiceAmount'
  },
  // 红冲详情查询
  acc_queryRedInvoiceInfo: {
    control: 'dyc/fsc/auto/invoice/queryRedInvoiceInfo'
  },
  // 诚富亦对账单下载
  acc_exportFscOrderPdf: {
    control: 'dyc/saas/fsc/exportFscOrderPdf'
  }
};